export const a11y = {
    ariaLabelTrigger: (isOpen, title) => `${isOpen ? 'Close' : 'Open'} ${title} menu`,
};
//# sourceMappingURL=strings.js.map